import * as React from 'react'
import cn from 'classnames'
import arrow from './arrow.png'
import styles from './free-handwriting.module.scss'

interface IFreeHandwritingProps {
  variant: 'left' | 'right'
  text?: React.ReactNode
  className?: string
  color?: 'black' | 'white'
}

const FreeHandwriting = ({ variant, text, className, color = 'black' }: IFreeHandwritingProps) => (
  <div className={cn(styles.handWriting, styles[variant], className, styles[color])} style={{ color }}>
    {text}
    <img alt="Handdrawn arrow" src={arrow} />
  </div>
)

export default FreeHandwriting
